<template>
  <div
    :style="style"
    class="dashboard-header"
  >
    <h1
      class="primary-heading"
    >
      {{ text }}
    </h1>
    <p
      class="subtitle"
      v-if="subtitle"
    >
      {{ subtitle }}
    </p>
    <slot />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    text: {
      default: '',
      type: String,
    },
    hasSlot: {
      default: false,
      type: Boolean,
    },
    subtitle: {
      default: '',
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      fonts: 'brand/getFonts',
    }),
    style() {
      return {
        display: this.hasSlot ? 'flex' : 'block',
        justifyContent: this.hasSlot ? 'space-between' : 'baseline',
      };
    },
  },
};
</script>
